import ViewsRouter from '@/views/ViewsRouter.vue'

import ViewsProducts from '@/views/products/ViewsProducts.vue';
import ViewsProductsProduct from '@/views/products/ViewsProductsProduct.vue';
import ViewsProductsProxy from '@/views/products/ViewsProductsProxy.vue';

import {home} from '@/router/breadcrumbs';
import {PERMISSIONS} from '@/constants';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/products/:grouping',
        name: 'products-parent',
        component: ViewsRouter,
        children: [
            {
                path: ':grouping_id?',
                name: 'products',
                component: ViewsProducts,
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [home],
                    permissions: [PERMISSIONS.EMPLOYEE]
                }
            },
            {
                path: 'proxy/:grouping_id',
                name: 'products.proxy',
                component: ViewsProductsProxy,
                meta: {
                    requiresAuth: true,
                    permissions: [PERMISSIONS.EMPLOYEE]
                }
            },
            {
                path: ':grouping_id/product/:sku',
                name: 'products.product',
                component: ViewsProductsProduct,
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [home],
                    permissions: [PERMISSIONS.EMPLOYEE]
                }
            }
        ]
    }
] as RouteRecordRaw[]
